import React from 'react';
import { useDarkMode } from 'src/context/DarkModeContext';
import ExplanationCard from 'src/components/cards/ExplanationCard/ExplanationCard';
import ExampleCard from 'src/components/cards/ExampleCard/ExampleCard';
import ExampleTitle from 'src/components/ExampleTitle';

import {
    activeAndPassiveVoiceExamples,
    vozActivaPasivaExplanation,
} from 'src/data/individual-topics/ActivePassiveVoice';

import { Example } from 'src/data/models/ExampleModel';
import PageStructure from 'src/components/wrappers/PageStructure';

const VozActivaPasivaContent: React.FC = () => {
    const { isDarkMode } = useDarkMode();

    return (
        <div className={`${isDarkMode ? 'dark' : ''}`}>
            <div className="section">
                <ExplanationCard cardData={vozActivaPasivaExplanation} />
            </div>

            <div className="section">
                <ExampleTitle title="Examples of Active vs Passive Voice" />
                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    {activeAndPassiveVoiceExamples.map((example: Example, index: number) => (
                        <ExampleCard key={index} example={example} />
                    ))}
                </div>
            </div>
        </div>
    );
};

const VozActivaPasivaScreen: React.FC = () => {
    return (
        <PageStructure
            TitleNode="Active vs. Passive Voice"
            Page={<VozActivaPasivaContent />}
        />
    );
};

export default VozActivaPasivaScreen;